import {query, transition, trigger} from "@angular/animations";

export const preventInitialChildAnimations =
	trigger("preventInitialChildAnimations", [
		transition(":enter", [
			query(":enter", [], {optional: true})
		])
	]);
